// src/hooks/useDeepLinkSubTable.ts
import { useNavigate } from "react-router-dom";

function useDeepLinkSubTable() {
	const navigate = useNavigate();

	const viewSlug = "inventory_items"; // Use the viewSlug from config

	return (
		groupUuid: string,
		primaryUuid: string,
		secondaryUuid: string,
		routeKeyPrimary: string,
		routeKeySecondary: string
	) => {
		// const parts = [
		// 	`${viewSlug}:group=${encodeURIComponent(groupUuid)}`,
		// 	`${viewSlug}:${routeKeyPrimary}=${encodeURIComponent(primaryUuid)}`,
		// 	`${viewSlug}:${routeKeySecondary}=${encodeURIComponent(
		// 		secondaryUuid
		// 	)}`,
		// ];

		const parts = [
			`${viewSlug}:group=${encodeURIComponent(groupUuid)}`,
			`${viewSlug}:${routeKeyPrimary}=${encodeURIComponent(primaryUuid)}`,
		];

		// pass hasSubTable:true in router state
		navigate(`/${viewSlug}?${parts.join("&")}`, {
			state: { hasSubTable: true },
		});
	};
}

export default useDeepLinkSubTable;
